module.exports = __webpack_public_path__ + "static/media/1-5-3.77373287.png";